import Tooltip from './Tooltip'

export default function FormFieldText (props) {
  return (
    <div className="wp-block-gds-lead-form__form-field">
      {props.label && (
        <label>
          {props.label}{props.required ? '*' : ''}
          {props.tooltip && <Tooltip>{props.tooltip}</Tooltip>}
        </label>
      )}
      <input
        type="text"
        required={props.required}
        value={props.value}
        onChange={e => props.onChange?.(e.target.value)}
      />
    </div>
  )
}
